// owner DoorDash photos (self-hosted) — fuzzy map, June 2026
const CANON = {"chilli": "chili", "kadhai": "kadai", "mutter": "matar", "muttar": "matar", "yoghurt": "yogurt", "veggie": "veg", "paratha": "paratha", "pakoda": "pakora"};
const DROP = new Set(["2pc", "2pcs", "4pc", "4pcs", "8oz", "full", "half", "large", "oz", "pc", "pcs", "regular"]);
export const normName = (n) => {
  let s = String(n || "").toLowerCase().split(/\u2014|\u2013/)[0].replace(/\(.*?\)|\[.*?\]/g, " ");
  return (s.match(/[a-z0-9]+/g) || []).filter((t) => !DROP.has(t)).map((t) => CANON[t] || t).join("");
};
export const DISH_PHOTOS = {
 "steamedbasmatirice": "/dish-photos/steamed-basmati-rice.jpg",
 "chickentikkamasala": "/dish-photos/chicken-tikka-masala.jpg",
 "kheer": "/dish-photos/kheer.jpg",
 "badammilk": "/dish-photos/badam-milk.jpg",
 "bantajeeranimbumasalasoda": "/dish-photos/banta-jeera-nimbu-masala-soda.jpg",
 "canadadry": "/dish-photos/canada-dry.jpg",
 "clubsoda": "/dish-photos/club-soda.jpg",
 "cocacola": "/dish-photos/coca-cola-regular.jpg",
 "cokezerosugar": "/dish-photos/coke-zero-sugar.jpg",
 "dietcoke": "/dish-photos/diet-coke.jpg",
 "dietpepsi": "/dish-photos/diet-pepsi.jpg",
 "limca": "/dish-photos/limca.jpg",
 "mangobliss": "/dish-photos/mango-bliss.jpg",
 "mintsaltedlassi": "/dish-photos/mint-salted-lassi.jpg",
 "pepsi": "/dish-photos/pepsi.jpg",
 "punjabisweetlassi": "/dish-photos/punjabi-sweet-lassi.jpg",
 "saltedlassi": "/dish-photos/salted-lassi.jpg",
 "sprite": "/dish-photos/sprite.jpg",
 "waterbottle": "/dish-photos/water-bottle.jpg",
 "chiligarlicchicken": "/dish-photos/chili-garlic-chicken.jpg",
 "soyachaap65": "/dish-photos/soya-chaap-65.jpg",
 "rasgulla": "/dish-photos/rasgulla-4pc.jpg",
 "gobiajwainparatha": "/dish-photos/gobi-ajwain-paratha.jpg",
 "paneertikka": "/dish-photos/paneer-tikka-dhaba-style.jpg",
 "amritsarichole": "/dish-photos/amritsari-chole.jpg",
 "paneerbuttermasala": "/dish-photos/paneer-butter-masala.jpg",
 "chilichicken": "/dish-photos/chilli-chicken.jpg",
 "chickenseekhkebab": "/dish-photos/chicken-seekh-kebab.jpg",
 "butterchicken": "/dish-photos/butter-chicken.jpg",
 "dalmakhani": "/dish-photos/dal-makhani.jpg",
 "punjabikadhipakora": "/dish-photos/kadhi-pakora.jpg",
 "plainnaan": "/dish-photos/plain-naan.jpg",
 "garlicnaan": "/dish-photos/garlic-naan.jpg",
 "jeerarice": "/dish-photos/jeera-rice.jpg",
 "gulabjamun": "/dish-photos/gulab-jamun.jpg",
 "masalachai": "/dish-photos/masala-chai.jpg"
};
